import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { isMobileDevice } from "../../utils/device";
import { userState } from "../../atom/atom";
import { getUserInfo } from "../../api/user";
import {
  getPhotographerInfo,
  getSavedPhotographerList,
} from "../../api/photographer";
import { getSavedPromotionList } from "../../api/promotion";
import icn_back from "../../assets/svgs/icn_back.svg";
import BottomBtns from "./BottomBtns";
import ProfileUser from "./ProfileUser";
import SavedContent from "./SavedContent";
import PhotographerInfo from "../../components/PhotographerInfo";
import MorePhotographerInfo from "../../components/MorePhotographerInfo";
import Bottom from "../../components/Bottom";

export default function MyPage() {
  const isMobile = isMobileDevice();
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<any>();
  const [savedPromotions, setSavedPromotions] = useState<any>([]);
  const [savedPhotographers, setSavedPhotographers] = useState<any>([]);
  const user = useRecoilValue(userState);
  const role = user.roles.includes("PHOTOGRAPHER") ? "PHOTOGRAPHER" : "USER";

  useEffect(() => {
    let ignore = false;
    const fetchUserInfo = async () => {
      const [resResult, promotionsResult, photographersResult] =
        await Promise.allSettled([
          role === "USER" ? getUserInfo() : getPhotographerInfo(user.id),
          getSavedPromotionList(),
          getSavedPhotographerList(),
        ]);
      if (ignore) return;
      if (resResult.status === "fulfilled") {
        setUserInfo(resResult.value);
      } else {
        console.error("Failed to load user profile", resResult.reason);
      }
      if (promotionsResult.status === "fulfilled") {
        setSavedPromotions(promotionsResult.value.items);
      }
      if (photographersResult.status === "fulfilled") {
        setSavedPhotographers(photographersResult.value.items);
      }
    };
    fetchUserInfo();
    return () => {
      ignore = true;
    };
  }, [role, user.id]);

  if (!userInfo) return <></>;
  return (
    <div className="relative flex flex-col min-h-dvh-safe gap-4">
      {userInfo.type === "USER" ? (
        <>
          <ProfileUser userInfo={userInfo} />
          <SavedContent
            savedPromotions={savedPromotions}
            savedPhotographers={savedPhotographers}
            role={userInfo.type}
          />
        </>
      ) : (
        <div className="border-b-8 bg-gray50 border-gray50">
          <div className="relative w-full h-40 bg-violet400">
            {isMobile && (
              <img
                className="absolute z-10 w-6 h-6 cursor-pointer top-3 left-4"
                onClick={() => navigate(-1)}
                src={icn_back}
                alt="뒤로가기"
              />
            )}
          </div>
          <div className="flex flex-col gap-2">
            <PhotographerInfo isMypage={true} userInfo={userInfo} />
            <SavedContent
              savedPromotions={savedPromotions}
              savedPhotographers={savedPhotographers}
              role={userInfo.type}
            />
            {userInfo.portfolio && userInfo.portfolio.length > 0 && (
              <MorePhotographerInfo userInfo={userInfo} />
            )}
          </div>
        </div>
      )}
      <BottomBtns />
      <div className="flex-1" />
      <Bottom />
    </div>
  );
}
